<template>
  <div class="relative aspect-16-9 bg-black">
    <iframe
      class="absolute inset-0"
      width="100%"
      height="100%"
      :src="sourceUrl"
      frameborder="0"
      allowfullscreen
      allow="autoplay"
    />
  </div>
</template>

<script>
export default {
    props: {
        sourceUrl: { type: String, required: true },
    },
}
</script>